export default "__VITE_ASSET__Cvt857o$__"